export default {
    submissionDeadline: 'Submission Deadline',
};
